import {
  ACCOUNT_ADMIN_COPY,
  ACCOUNT_ADMIN_SITE_SETUP_GUIDE,
} from '../../../accounts/constants/accountAdmin.constants'
import { ACCOUNT_ADMIN_BRANDING_PREVIEW } from '../../../accounts/constants/accountAdminBrandingPreview.constants'
import { ACCOUNT_ADMIN_SSO_COPY } from '../../../accounts/constants/accountAdminSso.constants'
import { BILLING_COPY } from '../../../accounts/constants/billingPlans.constants'

/** English org-admin UI copy (sidebar, tabs, dialogs, billing tab). */
export const accountAdminCopyEn = {
  backToSite: '← Back to site',
  ...ACCOUNT_ADMIN_COPY,
  setupGuide: ACCOUNT_ADMIN_SITE_SETUP_GUIDE,
  navShort: {
    START_HERE: 'Start',
    BRANDING: 'Brand',
    MEMBERS: 'Members',
    SETTINGS: 'Settings',
    PLAN_BILLING: 'Plan',
    INVOICE_DETAILS: 'Billing',
  },
  navLockedA11ySuffix: ' — complete billing to unlock',
  brandingPreview: ACCOUNT_ADMIN_BRANDING_PREVIEW,
  sso: ACCOUNT_ADMIN_SSO_COPY,
  billing: BILLING_COPY,
} as const

export type AccountAdminCopy = typeof accountAdminCopyEn
